import { Home } from './pages';

export default {
  key: 'home',
  isPrivate: false,
  exact: true,
  path: '/',
  component: Home,
};
